import { FC, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { trackPageView } from 'lib/ga4';

/**
 * RouteTracker component
 * Tracks page views for GA4 on every route change
 * Should be placed at the root of the router tree
 */
const RouteTracker: FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname + location.search);
  }, [location]);

  return <Outlet />;
};

export default RouteTracker;
